import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

const MaterialStyleMixin = () => {
  return {
    data () {
      return { isPlaceholder: false, elFormItem: null }
    },
    watch: { 'value': 'materialFiled' },
    created () {
      if (this.$options.name === 'ElSelect' || this.$options.name === 'ElDatePicker') {
        this.getInput = () => {
          if (this.$options.propsData.multiple) {
            this.$el.setAttribute('data-multiselect', true)
            return this.$refs.input
          } else {
            return this.$refs.reference.$refs.input
          }
        }
      }
    },
    mounted () {
      this.findElFormItem()
      if (this.elFormItem) {
        this.isPlaceholder = this.placeholder || (this.$options.name === 'ElInput' && this.getInput().getAttribute('placeholder'))
        this.materialFiled(this.value)
        if (!this.isPlaceholder) {
          this.getInput().addEventListener('focus', this.materialFocus)
          this.getInput().addEventListener('blur', this.materialFocus)
        }
      }
    },
    beforeDestroy () {
      if (this.elFormItem && !this.isPlaceholder) {
        this.getInput().removeEventListener('focus', this.materialFocus)
        this.getInput().removeEventListener('blur', this.materialFocus)
      }
    },
    methods: {
      findElFormItem () {
        const findFunc = (Component) => {
          if (!this.elFormItem) {
            if (Component.$options.name === 'ElFormItem') {
              this.elFormItem = Component
            } else if (Component.$options.name === 'root') {
              return false
            } else if (Component.$parent) {
              findFunc(Component.$parent)
            }
          }
        }
        findFunc(this.$parent)
      },
      handleChangeQuery (Value) {
        this.$emit('queryChange', Value)
      },
      valueToBool (Value) {
        if (this.$_.isArray(Value)) {
          return (Value.length)
        } else if (typeof Value === 'number') {
          return true
        } else {
          return (Value)
        }
      },
      materialFiled (Value) {
        // TODO fix
        if (!this.elFormItem) {
          return
        }
        if (this.isPlaceholder) {
          this.elFormItem.$el.setAttribute('data-filed', 'true')
        } else {
          this.elFormItem.$el[this.valueToBool(Value) ? 'setAttribute' : 'removeAttribute']('data-filed', true)
        }
      },
      materialFocus (e) {
        this.elFormItem.$el[e.type === 'focus' ? 'setAttribute' : 'removeAttribute']('data-focus', true)
      }
    }
  }
}
const InputChromeAutoCompleteMixin = () => {
  return {
    mounted () {
      let input = this._chrome_fix_get_input()
      if (input) {
        input.setAttribute('autocomplete', 'nope')
      }
    },
    methods: {
      _chrome_fix_get_input () {
        if (this.$refs.input) {
          return this.$refs.input
        } else if (this.$refs.reference && this.$refs.reference.$refs.input) {
          return this.$refs.reference.$refs.input
        }
      }
    }
  }
}
export default function () {
  ElementUI.Input.mixins.push(MaterialStyleMixin())
  if (/chrome/.test(window.navigator.userAgent.toLowerCase())) {
    ElementUI.Input.mixins.push(InputChromeAutoCompleteMixin())
    ElementUI.Select.mixins.push(InputChromeAutoCompleteMixin())
  }
  ElementUI.Select.mixins.push(_.merge(MaterialStyleMixin(), { watch: { 'query': 'handleChangeQuery' } }))
  ElementUI.Switch.mixins.push({
    methods: {
      focus (e) {
        if (e.type === 'focus') {
          this.$el.setAttribute('data-focus', true)
        } else if (e.type === 'blur') {
          this.$el.removeAttribute('data-focus')
        }
      }
    },
    mounted () {
      this.$refs.input.addEventListener('focus', this.focus)
      this.$refs.input.addEventListener('blur', this.focus)
    },
    beforeDestroy () {
      this.$refs.input.removeEventListener('focus', this.focus)
      this.$refs.input.removeEventListener('blur', this.focus)
    }
  })
  ElementUI.DatePicker.mixins.push(MaterialStyleMixin(), {
    props: {
      clearable: { type: Boolean, default: false }
    }
  })

  Vue.use(ElementUI, { locale })
}
